import { ChapterTag, MaskedLines, FadeUp } from "./Reveal";
import { BookButton } from "./CTA";

const STEPS = [
  { n: "01", title: "Book", text: "Book your free inspection online, by call or on WhatsApp. Takes under a minute." },
  { n: "02", title: "Inspect", text: "Our technician assesses the property and identifies the pest, source and entry points." },
  { n: "03", title: "Treat", text: "We explain the findings, recommend the appropriate treatment and perform it professionally." },
  { n: "04", title: "Follow Up", text: "We make sure the agreed pest-control solution is properly addressed, per our guarantee terms." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-24 lg:py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <ChapterTag index="05" label="The Process" />
      <div className="mt-10 max-w-3xl">
        <h2 data-testid="how-it-works-headline" className="font-display font-semibold text-charcoal tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
          <MaskedLines lines={[<>Getting rid of pests</>, <span className="italic text-wine">shouldn't be complicated.</span>]} />
        </h2>
      </div>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        {STEPS.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.12} className="relative border-t-2 border-wine pt-7">
            <span className="absolute -top-[2px] left-0 h-[2px] w-12 bg-gold" aria-hidden="true" />
            <span className="font-display italic text-gold text-lg">{s.n}</span>
            <h3 className="font-display text-3xl font-semibold text-charcoal uppercase tracking-wide mt-2">{s.title}</h3>
            <p className="text-sm text-stone2 leading-relaxed mt-3">{s.text}</p>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.35} className="mt-14">
        <BookButton testid="how-it-works-book-btn" />
      </FadeUp>
    </div>
  </section>
);
